import DatadogUtil from 'performance/DatadogUtil';
import {RouteBundle} from 'routing/RouteConstants';
import ExternalInvitePage from 'start/ExternalInvitePage';
import InvitePage from 'start/InvitePage';
import TaggerView from 'start/TaggerView';
import {renderReactComponent} from 'util/RootReactRender';

export const StartRoutes: RouteBundle = {
  domain: 'start',
  routes: [
    {urlPattern: 'tag', handler: tag, legacy: true},
    {urlPattern: 'invite', handler: invite, legacy: true},
    {urlPattern: 'external-invite', handler: externalInvite, legacy: true},
  ],
};

function tag(): void {
  DatadogUtil.startRUMView('tag');
  new TaggerView().render();
}

function invite(): void {
  DatadogUtil.startRUMView('invite');
  renderReactComponent(InvitePage);
}

function externalInvite(): void {
  DatadogUtil.startRUMView('external_invite');
  renderReactComponent(ExternalInvitePage);
}
